import { FormItem } from '../../../../../commons/Form/Form.types';
import { DashboardProspectsFormSchema } from './DashboardProspectsCOMForm.types';

export const createProspectStepData: FormItem<DashboardProspectsFormSchema>[][] = [
  [
    {
      name: 'name_company',
      placeholder: "Nom de l'entreprise...",
      label: "Nom de l'entreprise",
      type: 'text',
      required: true,
    },
    {
      name: 'name',
      placeholder: 'Nom du prospect...',
      label: 'Nom',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'email',
      placeholder: 'Adresse email du prospect...',
      label: 'Adresse email',
      type: 'text',
      required: true,
    },
    {
      name: 'phone',
      placeholder: 'Numéro de téléphone du prospect...',
      label: 'Téléphone',
      type: 'tel',
      required: true,
    },
  ],
];
